import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=31d43b40"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"
import style0 from "./Error404.vue?vue&type=style&index=0&id=31d43b40&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d43b40')) {
      api.createRecord('31d43b40', component.options)
    } else {
      api.reload('31d43b40', component.options)
    }
    module.hot.accept("./Error404.vue?vue&type=template&id=31d43b40", function () {
      api.rerender('31d43b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Error404.vue"
export default component.exports